import { Component } from '@angular/core';
import { DataExportService } from '../../services/data-export.service';
import { MatDialogRef } from '@angular/material/dialog';
import {
  AchiveBillerDialogComponent
} from '../../../billers/components/achive-biller-dialog/achive-biller-dialog.component';

@Component({
standalone: false,
  selector: 'app-export-data-dialog',
  templateUrl: './export-data-dialog.component.html',
  styleUrls: ['./export-data-dialog.component.scss']
})
export class ExportDataDialogComponent {

  public exportingData = false;
  public error = false;

  constructor(
    private dataExportService: DataExportService,
    private dialogRef: MatDialogRef<AchiveBillerDialogComponent>,
  ) {
  }

  public onFetchCustomerDataClick(): void {
    this.exportingData = true;
    this.dataExportService.fetchCustomerExportedData()
      .subscribe(() => {
        this.dialogRef.close();
      }, () => {
        this.exportingData = false;
        this.error = true;
      });
  }

}
